import { AskHRFormActivity } from './Activities/AskHRFormActivity';
import { TempLinkActivity } from './Activities/TempLinkActivity';
import { ActivityType } from './AskHRBot.types';

export const activities: { [key: string]: any } = {
    [ActivityType.MESSAGE]: TempLinkActivity,
    [ActivityType.AskHRForm]: AskHRFormActivity,
};
